import React from 'react';
import './termsstyles.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms of Service</h1>
      <p className="terms-intro">Welcome to ArCity, your trusted travel companion for exploring Pakistan's most beautiful destinations. Please read our terms of service carefully before using our website.</p>
      
      <div className="terms-section">
        <h2 className="terms-heading">1. Acceptance of Terms</h2>
        <p className="terms-text">By accessing or using our services, you agree to be bound by these terms. If you do not agree with any part of these terms, you should discontinue use of our website.</p>
      </div>

      <div className="terms-section">
        <h2 className="terms-heading">2. Use of Our Services</h2>
        <p className="terms-text">You agree to use our services for lawful purposes only. Any unauthorized use of our website or services is prohibited.</p>
      </div>

      <div className="terms-section">
        <h2 className="terms-heading">3. Content Ownership</h2>
        <p className="terms-text">All content provided on this website is owned by ArCity unless otherwise stated. You may not reproduce, distribute, or use any content without prior written permission.</p>
      </div>

      <div className="terms-section">
        <h2 className="terms-heading">4. Travel Bookings</h2>
        <p className="terms-text">All travel bookings made through our website are subject to the terms and conditions of the respective service providers.</p>
      </div>

      <div className="terms-section">
        <h2 className="terms-heading">5. Limitation of Liability</h2>
        <p className="terms-text">ArCity will not be liable for any damages arising from the use or inability to use our services, including but not limited to direct, indirect, incidental, or consequential damages.</p>
      </div>

      <div className="terms-section">
        <h2 className="terms-heading">6. Modifications to Terms</h2>
        <p className="terms-text">We reserve the right to modify these terms at any time. We will notify you of any changes by posting the new terms on our website.</p>
      </div>

      <div className="terms-section">
        <h2 className="terms-heading">7. Governing Law</h2>
        <p className="terms-text">These terms are governed by and construed in accordance with the laws of Pakistan. Any disputes arising from these terms will be resolved in the courts of Pakistan.</p>
      </div>
    </div>
  );
};

export default TermsOfService;
